import React from "react";
import { ZM5T3cR8wIQ } from "./zM5T3cR8wIQ";

const IndexPage = () => <ZM5T3cR8wIQ />;

export default IndexPage;
